import i18n from "../Localization";

const Translate = (key) => {
  const result = i18n.t(key);
  return result;
};

export default Translate;
